import React, { Component } from "react";
import ReactDOM from "react-dom";
import cn from "classnames";
import Layout from "./Layout";
import "./HorizontalLayout.less";

const CLASS_NAME = "fct-horizontal-layout";
const VERTICAL_ALIGN = {
  TOP: "_top",
  MIDDLE: "_middle",
  BOTTOM: "_bottom",
  STRETCH: "_stretch"
};

class HorizontalLayout extends Component {
  static defaultProps = {
    scrollx: true,
    verticalAlign: VERTICAL_ALIGN.TOP
  };

  render() {
    const { children, verticalAlign, className, ...props } = this.props;
    return (
      <Layout className={cn(CLASS_NAME, verticalAlign, className)} {...props}>
        {this._renderChildren()}
      </Layout>
    );
  }

  _renderChildren() {
    const { lgap, rgap, tgap, bgap, hgap, vgap, children } = this.props;
    if (
      lgap == null &&
      rgap == null &&
      tgap == null &&
      bgap == null &&
      hgap == null &&
      vgap == null
    ) {
      return children;
    }
    return React.Children.map(children, (child, i) => {
      return React.cloneElement(child, {
        ...(lgap != null || hgap != null
          ? {
              _lgap:
                (i === 0 ? hgap || 0 : 0) +
                (lgap || 0) +
                (child.props.lgap || 0)
            }
          : {}),
        ...(rgap != null || hgap != null
          ? {
              _rgap: (hgap || 0) + (rgap || 0) + (child.props._rgap || 0)
            }
          : {}),
        ...(tgap != null
          ? {
              _tgap: (tgap || 0) + (child.props._tgap || 0)
            }
          : {}),
        ...(bgap != null
          ? {
              _bgap: (bgap || 0) + (child.props._bgap || 0)
            }
          : {}),
        ...(vgap != null
          ? {
              _vgap: (vgap || 0) + (child.props._vgap || 0)
            }
          : {})
      });
    });
  }
}
HorizontalLayout.VERTICAL_ALIGN = VERTICAL_ALIGN;
export default HorizontalLayout;



// WEBPACK FOOTER //
// ./layout/HorizontalLayout.js